import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import {
  EVENT_FORM_EVENT_TEMPLATES,
  EVENT_FORM_VENUE_TEMPLATES,
} from '../../constants/tableTypes'
import tableReducer from './columnDefinitions'

const initialState = {
  content: [],
  total_elements: 0,
}

const eventTemplatesReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return reducers.dataTable.tableFetchReducer(
        EVENT_FORM_EVENT_TEMPLATES,
        state,
        action
      )
  }
}

const venueTemplatesReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return reducers.dataTable.tableFetchReducer(
        EVENT_FORM_VENUE_TEMPLATES,
        state,
        action
      )
  }
}

const eventFormEventTemplates = combineReducers({
  data: eventTemplatesReducer,
  tableInfo: tableReducer,
})

const eventFormVenueTemplates = combineReducers({
  data: venueTemplatesReducer,
  tableInfo: tableReducer,
})

export { eventFormEventTemplates, eventFormVenueTemplates }
